var a = /* @__PURE__ */ ((r) => (r.EXTRA_SMALL = "extra-small", r.SMALL = "small", r.MEDIUM = "medium", r.LARGE = "large", r))(a || {}), A = /* @__PURE__ */ ((r) => (r.PRIMARY = "primary", r.SECONDARY = "secondary", r))(A || {});
export {
  a as VSpinnerSizes,
  A as VSpinnerVariants
};
